import { Id, Json, DomainEntity } from "@homeleite/arch";
import { EMPTY } from "@homeleite/common-utils";

export class HerdoutReasonSummary implements DomainEntity {
    constructor(
        public readonly id = Id.gen(),
        public description: string = EMPTY,
        public status = true,
    ) { }

    toJson() {
        return Json.to.simple(this);
    }

    static fromJson(json: HerdoutReasonSummary) {
          return json ? Json.from.simple(json, HerdoutReasonSummary) : null;
    }
}
